import { Component, createRef } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {set_datapage} from 'redux/actions/DataPageAction'

import { Button, 
  Card, 

  Section, 
  Form,
   } from 'react-bulma-components';
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from 'jquery'
import dt from 'datatables.net'
import qs from 'query-string'
import { Link, Redirect, useHistory } from "react-router-dom";

import Swal from "sweetalert2";
import {PageLength} from "helpers/Datatables";
import { SpinLoader } from "layouts/mainsection/components/Loader";
import { createHChart, createHChartMaps } from "layouts/mainsection/components/CHighchartTools";
// import { Highcharts } from "highcharts/modules/map";
import Highcharts from 'highcharts/highmaps';
window.Highcharts = Highcharts
require('@highcharts/map-collection/custom/world');
require('@highcharts/map-collection/custom/south-america');
$.DataTable = dt



class Indicadores extends Component {
    state = {
        totalIndicadores: false,
        listIndicadores: [],
        currentCategoria: false,
        currentIndicador: false,
        listYears: [],
        listPaises: [],
        loaderSuccess: false,
        currentChartMap: null,
        dataCharts: {
          aperture: false,
          showGenerar: true,
          chartMap: null,
          boxs: []
        }
    }
    filter = {
        buscar: '',
        type: -1
    }
    table = null
    datatable = null
    selectIndicador = null
    selectCategorias = null
    selectPais = null
    selectYear = null
    constructor (props) {
        super(props)
        this.requestInit = axios.CancelToken.source()
        this.props.set_datapage({ titulo: 'Indicadores'});

        this.selectIndicador = createRef()
        this.selectCategorias = createRef()
        this.selectPais = createRef()
        this.selectYear = createRef()
    }
    componentDidMount () {
      if(this.state.listIndicadores.length==0){
        this.init()
      }        
    }
    
    init = () => {      

      axios.get(baseUrl(`cites/indicadores`), {cancelToken: this.requestInit.token}).then(res => {

        
        var params=qs.parse(this.props.location.search)
        var indicador=false
        var categoria=false
        if((params["ind"])){
          indicador=params["ind"]
        } 
        if((params["cat"])){
          categoria=params["cat"]
        } 
        this.setState({
            listIndicadores: res.data.indicadores,
            listYears: res.data.years,
            listPaises: res.data.paises,
            currentIndicador: indicador,
            currentCategoria: categoria,
            dataCharts: {
              ...this.state.dataCharts,
              // boxs: res.data.boxs
            }
        })
        let cate =  res.data.indicadores.find(item => item.code === categoria)
        if (cate !== undefined) {
          // console.log('indicadores',cate)
          let indi= cate.indicadores.find(item => item.key === indicador)
          if (indi !== undefined) {          
            this.props.set_datapage({ titulo: 'Indicador - '+indi.title});
            this.callServer(indicador)
          }
        }
  
        
      })

      // this.setState({isIdArray : Array.isArray(this.props.id)})
      this.setState({
        dataCharts: {
          ...this.state.dataCharts,
          chartMap: createHChartMaps('GeoChartTTT', 
          {
            chart: {
                map: Highcharts.maps['custom/south-america']
            },
        
            title: {
                text: 'Distribution',
                style: {display: 'none'}
            },
            legend: {
              enabled: false
            },
            tooltip: {
              enabled: true
            },
            colorAxis: {
                min: 0
            },
        
            series: [{
                data: [],
                // data: this.state.currentDataEspecie.pli_txt_distribution.split(',').map((cpitem, index) => {
  
                //       // let opais = this.state.currentDataEspeciePaises.find(op =>  op.code.trim() === cpitem.trim())
                //       // return [{v: cpitem.trim(), f: opais ? opais.name : cpitem.trim()}, index]
                //       return [cpitem.trim().toLowerCase(), +index + Math.random()]
                // }),
                name: 'Random data',
                states: {
                    hover: {
                        color: '#BADA55'
                    }
                },
                tooltip: {
                  headerFormat: '',
                  pointFormat: '{point.name}({point.value})'
                },
                dataLabels: {
                    enabled: true,
                    // format: '',
                    formatter: function () {
                      if (this.point.value) {
                          return this.point.value;
                      }
                  }
                }
            }]
          }, chartRes => {
            
            this.setState({
              currentChartMap: chartRes
            })
            // chartRes.series[0].update(
            //   {
            //     data: [['pe', 1]]
            //   }
            // )
          })
        }
      }) 
    }
    onScriptLoad = () => {
      window.google.charts.load('current', {
        'packages':['geochart', 'corechart'],
        // Note: you will need to get a mapsApiKey for your project.
        // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
        'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
      });

      window.google.charts.setOnLoadCallback(this.drawCharts);
    }
    drawCharts = () => {
      this.setState({
        loaderSuccess: true
      })
      // this.loadMaps()
      // this.loadPie()
      // this.loadBars()
    }
    getBoxs = () => {
      let testt = <div id="casaita"></div>
      // console.log(testt)
      this.state.dataCharts.boxs.forEach((item, index) => {
        // testt.props
      })
      let parse = []
      let k = 0
      for (let i = 0; i < Math.round(this.state.dataCharts.boxs.length/2); i ++) {
        let n = []
        for (let j = 0; j < 2; j ++) {
          if (this.state.dataCharts.boxs[k] !== undefined) {
            n.push(this.state.dataCharts.boxs[k])
            k++
          }
        }
        parse.push(n)
      }
      return parse.map((columns, ii) => {
        return <div className="columns" key={`columns${ii}`}>
          { columns.map((column, ji) => {
            return <div className="column" key={`column${ii}${ji}`}>
              {createHChart(`chart${ii}${ji}`, column, fcall => {})}
            </div>
          }) }
        </div>
      })
    }
    loadMaps = (data) => {
      var data = window.google.visualization.arrayToDataTable([
        ['Country', 'Popularity'],
        ...data.data.map(item => {
          return [item.pai_txt_isocode, item.permisos]
        })
        
      ]);

      var options = {
         region: '005',
        title: data.title,

        //  displayMode: 'text',
        //  magnifyingGlass: {enable: true, zoomFactor: 17.5},
         sizeAxis: { minValue: 0, maxValue: 100 },
        //  colorAxis: {colors: ['#00853f', 'black', '#e31b23']},
        //   backgroundColor: '#81d4fa',
        //   datalessRegionColor: '#f8bbd0',
        //   defaultColor: '#f5f5f5',
      };

      var chart = new window.google.visualization.GeoChart(document.getElementById('regions_div'));

      chart.draw(data, options);
    }

    loadPie = (dataref) => {
      var data = new window.google.visualization.DataTable();
      data.addColumn('string', data.title);
      data.addColumn('number', 'Populartiy');
      data.addRows([
        ...dataref.data.map(item => [item.var_txt_name, +item.permisos])
        // ['Pepperoni', 33],
        // ['Hawaiian', 26],
        // ['Mushroom', 22],
        // ['Sausage', 10], // Below limit.
        // ['Anchovies', 9] // Below limit.
      ]);

      var options = {
        title: dataref.title,
        sliceVisibilityThreshold: .2
      };

      var chart = new window.google.visualization.PieChart(document.getElementById('regions_pie'));
      chart.draw(data, options);
    }
    componentWillUnmount() {
      
      if (this.requestInit) this.requestInit.cancel()


    }
    loadBars = (dataref) => {
      var data = window.google.visualization.arrayToDataTable([
        // ["Element", "Density", { role: "style" } ],
        ["Element", "Density"],
        ...dataref.data.map(item => [item.per_text_taxon, +item.permisos])

        // ["Copper", 8.94, "#b87333"],
        // ["Silver", 10.49, "silver"],
        // ["Gold", 19.30, "gold"],
        // ["Platinum", 21.45, "color: #e5e4e2"]
      ]);

      var view = new window.google.visualization.DataView(data);
      // function getValueAt (column, dataTable, row) {
      //   return dataTable.getFormattedValue(row, column);
      // }
      // view.setColumns([0, 1,{ 
      //                   // calc: "stringify",
      //                   calc: getValueAt.bind(undefined, 1),
      //                   sourceColumn: 1,
      //                   type: "string",
      //                   role: "annotation" },
      //                  2]);

      var options = {
        title: dataref.title,
        // width: 600,
        height: 400,
        bar: {groupWidth: "95%"},
        legend: { position: "none" },
      };
      var chart = new window.google.visualization.ColumnChart(document.getElementById("regions_bar"));
      chart.draw(view, options);
    }



    COptionsYears = () => {
        return this.state.listYears.map((item, index) => <option key={index} value={item}>{item}</option>)
    }
    COptionsPaises = () => {
        return this.state.listPaises.map((item, index) => <option key={index} value={item.code}>{item.name}</option>)
    }

    OnChangeFilter = (evt) => {
      this.callServer()

    }

    onSubmit_filter = (evt) => {
        evt.preventDefault()
        if (this.state.currentIndicador) {

          this.onClick_btnGenerar()
        }
        // console.log(evt)
        // this.filter.buscar = evt.target.elements.search.value
        // this.filter.type = evt.target.elements.filterType.value
        // this.datatable.draw()

    }

    onClick_btnGenerar = evt => {
      this.callServer(this.state.currentIndicador)
    }
    onClick_loadIndicador= evt=>{

      
      this.props.history.push(localUrl('/indicadores?cat='+evt.currentTarget.getAttribute('data-cat')+'&ind=' + evt.currentTarget.getAttribute('data-key')))
      this.setState({
        currentCategoria: evt.currentTarget.getAttribute('data-cat'),
        currentIndicador: evt.currentTarget.getAttribute('data-key')
      })
      this.callServer(evt.currentTarget.getAttribute('data-key'))

    }
    menuIndicadores=() =>{

      return (
      <aside className="menu">
        <ul className="menu-list">
          {this.state.listIndicadores.map((item, index) => <li key={item.code}>
                                                            <label className="label">{item.cate}</label>                                                            
                                                            <ul>
                                                            {item.indicadores.map((itemi, indexi) => 
                                                                <li key={indexi} >
                                                                  {itemi.key==this.state.currentIndicador?(
                                                                  <a data-cat={item.code} data-key={itemi.key} className='is-active'>
                                                                   {itemi.title} 
                                                                  </a>
                                                                  ):
                                                                  (
                                                                  <a data-cat={item.code} data-key={itemi.key} onClick={this.onClick_loadIndicador}>
                                                                   {itemi.title} 
                                                                  </a>
                                                                  )
                                                                  }
                                                                </li>)}
                                                            </ul>
                                                            </li>)}
        </ul>
      </aside>)
    }

    callServer(currentIndicador){
      this.setState({
        dataCharts: {
          ...this.state.dataCharts,
          aperture: false,
          showGenerar: false,
          boxs: []
        }
      }) 
      axios.get(baseUrl('cites/indicadores/consulta'), {
        params: {
          indicador: currentIndicador,
          pais: this.selectPais.current.value,
          year: this.selectYear.current.value
        },
        cancelToken: this.requestInit.token
      }).then(res => {
        if(res.data.total){
          let pais = this.state.listPaises.find(item => item.id === this.selectPais.current.value)
          this.state.currentChartMap.series[0].update({
            // data: pais !== undefined ? [[pais.code.toLowerCase(), 1]] : []
            data: res.data.paises.map(item => [item[0].toLowerCase(), +item[1]])
          })
          
          this.setState({
            listYears: res.data.years,
            totalIndicadores: res.data.total,
            dataCharts: {
              ...this.state.dataCharts,
              aperture: true,
              showGenerar: true,
              boxs: res.data.boxs
            }
          })
        }else{
          this.setState({
            totalIndicadores: res.data.total,
            aperture: true,
          })

        }
      })
    }



    render() {
      if(this.state.listIndicadores.length>0){
        return (
          <Section className="is-main-section">           
            <Card>
              <Card.Content>           
                <div className="columns">
                  <div className="column is-half is-3">
                    {this.menuIndicadores()} 
                  </div>
                  <div className="column ">
                    <form action="" onSubmit={ this.onSubmit_filter }>
                      <div className="columns is-vbottom">
                          <div className='column is-2'>
                          <div className="field">
                            <div className="control is-expanded">
                              <label htmlFor="filterIndicador" className="label">País</label>                          
                              <span className="select is-empty is-expanded">
                                <select ref={ this.selectPais } 
                                  id="filterIndicadorPais" name="filterIndicadorPais" required="required">
                                  <option value="-1"> - Todos -
                                  </option>
                                  { this.COptionsPaises()}
                                </select></span></div>
                          </div>
                          </div>
                          <div className='column is-2'>
                          <div className="field">                            
                            <div className="control is-expanded">
                            <label htmlFor="filterIndicador" className="label">Año</label>
                              <span className="select is-empty is-expanded">
                                <select ref={ this.selectYear } 
                                  id="filterIndicadorYear" name="filterIndicadorYear" required="required">
                                  <option value="-1"> - Todos -
                                  </option>
                                  { this.COptionsYears() }
                                </select></span></div>
                          </div>
                          </div>
                          <div className='column is-2'>
                          <div className="field">
                            <div className="control">
                              <button type="submit" id="btnGenerarIndicador" disabled={ !this.state.dataCharts.showGenerar } 
                                  className="button is-primary">
                                    <div>
                                      <div style={ !this.state.dataCharts.showGenerar ? {
                                          height: '0px',
                                          overflow: 'hidden',
                                        } : {} }>Generar</div>
                                      { this.state.dataCharts.showGenerar ? null : SpinLoader}
                                    </div>
                                  </button>
                            </div>
                          </div>
                          </div>
                        </div>
                    </form>
                    
                    <div className='columns is-vcentered'>
                        {this.state.totalIndicadores==-1?(
                        <p>Sin Resultados!...</p>
                        ):''
                        }
                        <div className='column'>
                          {this.state.dataCharts.aperture && this.state.totalIndicadores!=-1?(
                          <div className="has-text-centered">                         
                                <p class="title">{ this.state.totalIndicadores.value}</p>
                                <p class="subtitle">{this.state.totalIndicadores.title}</p>
                          </div>
                          ):(
                            this.state.totalIndicadores!=-1?(
                            <section className="section">
                            <div className="columns is-centered">
                              <div class="column is-half has-text-centered">
                                {SpinLoader}
                              </div>                    
                            </div>
                            </section>
                            ):''
                          )                   
                          }
                        </div>
                        <div className='column'>
                        <div className={ this.state.dataCharts.aperture && this.state.totalIndicadores!=-1? '' : 'is-hidden'}>
                        {this.state.dataCharts.chartMap}
                        </div>
                        
                        {this.state.dataCharts.aperture==false?(
                          
                          <section className="section">
                          <div className="columns is-centered">
                            <div class="column is-half has-text-centered">
                              {SpinLoader}
                            </div>                    
                          </div>
                          </section>
                        ):''
                        } 
                        </div> 
                    </div>                   
                    <Card className={ this.state.dataCharts.aperture && this.state.totalIndicadores!=-1 && this.state.dataCharts.boxs.length>0? '' : 'is-hidden' }>
                      <Card.Header>
                        <Card.Header.Title>
                          <span className="icon"><i className="mdi mdi-finance"></i></span>Resumen
                        </Card.Header.Title> 

                        </Card.Header>
                      <Card.Content>
                        { this.getBoxs() }
                      </Card.Content>
                    </Card>
                  </div>                
                </div>
                
             

              </Card.Content>
            </Card>
           
          </Section>
        )
      }else{
        return (
          <section className="section">
          <div className="columns is-centered">
            <div class="column is-half has-text-centered">
              {SpinLoader}
            </div>                    
          </div>
          </section>
        )
      }
    }
}

export default connect(null, {set_datapage})(Indicadores)